import { Party } from "../api/models";
import { FormGroup, FormArray, Validators, FormControl, FormBuilder } from '@angular/forms';

export function matchClientPartyRow(search: string, searchRow: Party): boolean {
    search = search.toLowerCase();
    // Two "search" columns: [id:number, name:string]
    let searchColumns = [searchRow.clientParty.mailStop.toLowerCase(), searchRow.partyName.toLowerCase()];
    let terms = search.split(' ');

    return terms.filter((term) => {
        let isNum = term.match(/^[0-9]*$/gm);
        // If a search term is numbers, look on the int column (idx 0), else search the string coulmn (idx 1)
        return isNum ?
            searchColumns[0].startsWith(term)
            : (searchColumns[1].indexOf(term) > -1);
    }).length === terms.length; // Only a match if all search terms are found in a search column
}

/*
* ObjectToFormGroup
* - Convert an object literal into an Angular Reactive FormGroup object.
* - Quicker angular reactive form generation for simple "DaaS/DTO Forms".
* - Will ignore nulls unless told to keep them.
* - Must pass in an FormBuilder object, which needs to be DI'd into your component class.
*/
export function ObjectToFormGroup(dataDTO: any, formBuilder: FormBuilder, keepNulls = false): FormGroup {
    let form = formBuilder.group({});

    for (let key of Object.keys(dataDTO)) {

      // Ignore null data (generally in DTOs from DaaS) unless forced
      if (!keepNulls && (dataDTO[key] === null || dataDTO[key] === undefined)) { continue; }

      if (Array.isArray(dataDTO[key])) {
        let fa = new FormArray([], [Validators.required]);
        form.addControl(key, fa);

        for (let obj of dataDTO[key]) {
          fa.push(ObjectToFormGroup(obj, formBuilder));
        }
      } else {
        let fc = new FormControl('', Validators.required);
            fc.setValue(dataDTO[key]);
        form.addControl(key, fc);
      }
    }

    return form;
}